// Export the Registration API.
export default {
	apiService: {
		postRegister: {
			PATH_SEARCH: '/fusionAuth/registration/',
			PATH_METHOD: 'post',
		},
	},
};
